/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'

interface SideNavContextType {
  isMenuCollapsed: boolean
  activeMenuSection: React.RefObject<HTMLAnchorElement | null> | null
  activeMenuItem: React.RefObject<HTMLElement | null> | null
  expandedMenuSection: React.RefObject<HTMLElement | null> | null
  setActiveMenuSection: (ref: React.RefObject<HTMLAnchorElement | null>) => void
  setExpandedMenuSection: (ref: React.RefObject<HTMLElement | null> | null) => void
  setActiveMenuItem: (ref: React.RefObject<HTMLElement | null>) => void
  expandMenu: () => void
  collapseMenu: () => void
}

export const SideNavContext = React.createContext<SideNavContextType | null>(null)
